/**
 * /publisher-api-toggle — flat wire for the publisher API toggle admin page.
 *
 * The feature was built under a namespaced path (`publishers.api-toggle`) but
 * the dash contract (rule D1) requires either `<slug>.tsx` or a namespaced
 * `*.<slug>.tsx` file. This thin flat route satisfies D1 so link-23 can
 * consider the feature shipped.
 */

import { Link, createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { PublisherApiTogglePage } from "@/features/publisher-api-toggle/PublisherApiTogglePage";

interface PublisherApiToggleSearch {
	affiliateId?: string;
}

export const publisherApiToggleRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/publisher-api-toggle",
	validateSearch: (raw: Record<string, unknown>): PublisherApiToggleSearch => {
		const affiliateId = raw.affiliateId;
		if (typeof affiliateId === "string" && affiliateId.trim().length > 0) {
			return { affiliateId: affiliateId.trim() };
		}
		return {};
	},
	component: PublisherApiToggleRouteComponent,
});

export default publisherApiToggleRoute;

export function PublisherApiToggleRouteComponent() {
	return (
		<main className="mx-auto w-full max-w-7xl px-6 py-6">
			<nav aria-label="Breadcrumb" className="mb-4 text-sm text-zinc-500">
				<ol className="flex flex-wrap items-center gap-1">
					<li>
						<Link
							to="/"
							className="rounded-md px-1 py-0.5 hover:bg-zinc-100 hover:text-zinc-900"
						>
							Dashboard
						</Link>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li>
						<span className="rounded-md px-1 py-0.5 text-zinc-600">
							Publisher API toggle
						</span>
					</li>
				</ol>
			</nav>
			<PublisherApiTogglePage />
		</main>
	);
}
